module.exports = __webpack_public_path__ + "public/media/step_6_view_drawings.low.d324209a.mp4";